export default __webpack_public_path__ + "static/media/img_selected-industry-education.ad78d6a9.svg";